/* Decotimber · Lote 4. Completes card prices whose sale mode is not certain from the first 250 variants:
   reads every variant page through the dt-variant-prices section and repaints only when all pages arrived. */
(() => {
  'use strict';
  if (window.DecotimberCardPrices) { window.DecotimberCardPrices.init(document); return; }
  const cache = new Map();

  async function page(url, number, param) {
    const target = new URL(url, window.location.origin);
    target.searchParams.set('section_id', 'dt-variant-prices');
    if (number > 1) target.searchParams.set(param || 'page', number);
    const response = await fetch(target.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-dt-variant-prices]');
    if (!node) throw new Error('Missing variant prices');
    return JSON.parse(node.textContent);
  }

  async function catalog(url) {
    const first = await page(url, 1);
    if (!(first.pages >= 1 && first.pages <= 20)) throw new Error('Invalid variant pagination');
    const pages = [first];
    for (let n = 2; n <= first.pages; n++) {
      const next = await page(url, n, first.param);
      if (next.page !== n || next.total !== first.total) throw new Error('Incomplete variant pagination');
      pages.push(next);
    }
    if (pages.reduce((sum, p) => sum + p.count, 0) !== first.total) throw new Error('Variant count mismatch');
    return pages;
  }

  function minimums(pages, position) {
    const result = {}, money = {};
    pages.forEach(p => {
      Object.assign(money, p.money);
      String(p.mins[position] || '').split('|').forEach((value, i) => {
        if (value === '') return;
        const kind = 'amu'[i], cents = Number(value);
        if (!(kind in result) || cents < result[kind]) result[kind] = cents;
      });
    });
    return { result, money };
  }

  async function complete(el) {
    const url = el.dataset.url;
    if (!cache.has(url)) cache.set(url, catalog(url));
    const pages = await cache.get(url);
    const t = pages[0].t, { result, money } = minimums(pages, el.dataset.pos);
    const kinds = [...el.dataset.kinds].filter(k => k in result);
    if (!kinds.length || [...el.dataset.kinds].some(k => !(k in result))) throw new Error('Missing sale mode prices');
    const price = k => money[String(result[k])] || '';
    if (el.dataset.layout === 'family') {
      el.textContent = (el.dataset.name ? t.family_from : t.family_plain).replace('[name]', el.dataset.name || '').replace('[price]', price(kinds[0])).replace('[unit]', t[`word_${kinds[0]}`]).trim();
    } else {
      const main = el.querySelector('[data-dt-price-main]') || el.insertBefore(Object.assign(document.createElement('p'), { className: 'dt-price__main' }), el.querySelector('[data-dt-price-note]'));
      main.dataset.dtPriceMain = '';
      main.textContent = `${price(kinds[0])} ${t[`per_${kinds[0]}`]}`;
      const parts = [];
      if (el.dataset.varies === 'true') parts.push(t.from);
      if (kinds[1]) parts.push(t.note_from.replace('[unit]', t[`word_${kinds[1]}`]).replace('[price]', price(kinds[1])));
      else if (t.taxes_included) parts.push(t.taxes_included);
      const note = el.querySelector('[data-dt-price-note]');
      if (note) note.textContent = parts.join(' · ');
    }
    el.removeAttribute('data-pending');
  }

  function init(root) {
    (root || document).querySelectorAll('[data-dt-price][data-pending]:not([data-dt-busy])').forEach(el => {
      el.dataset.dtBusy = '';
      complete(el).catch(error => console.error('[Decotimber prices]', error));
    });
  }

  window.DecotimberCardPrices = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('decotimber:collection:updated', event => init(event.target));
})();
